import { type NutrientGroup } from "./nutrientPlots";
import { createNutrientPlotColorScale } from "../../../shared/utils/nutrientPlotColors";

// The map colours and outlines plots from the shared trial state's
// `ratesDosage.rates_and_dosages`, one list per plot group, in the same shape
// the old Rates & Dosage screen wrote. This builds that shape from the new
// Nutrient tab's own state.
export interface MapRatesDosageItem {
  plot_id: string;
  rate: number;
  variety: string;
  // Plots the user has switched on with the eye button: drawn with a thicker
  // outline on the map.
  collapseValue: string[];
  fertiliser_rate: number | null;
  fertiliser_amount: number;
  mapFillColor: string;
  mapOutlineWidth: number;
  mapDefaultOutlineWidth: number;
}

export const toMapRatesAndDosages = (
  groups: NutrientGroup[],
  applyByPlot: Record<string, number | null>,
  totalRate: number,
  highlightedPlotIds: string[]
): MapRatesDosageItem[][] => {
  const getPlotColor = createNutrientPlotColorScale(
    groups.flatMap((group) => group.plots.map((plot) => applyByPlot[plot.id]))
  );

  return groups.map((group) =>
    group.plots.map((plot) => {
      const applyPercent = applyByPlot[plot.id] ?? null;
      return {
        plot_id: plot.id,
        rate: 0,
        variety: "",
        collapseValue: highlightedPlotIds,
        fertiliser_rate: applyPercent,
        fertiliser_amount:
          applyPercent && totalRate ? (applyPercent / 100) * totalRate : 0,
        mapFillColor: getPlotColor(applyPercent),
        mapOutlineWidth: 7,
        mapDefaultOutlineWidth: 2,
      };
    })
  );
};
